import React from 'react';
import { classes } from '../../../lib';
import Styles from './Orb.module.less';

export type OrbProps = {
    color: 'blue' | 'red' | 'yellow';
    children: React.ReactNode;
    className?: string;
};

export const Orb = ({ color, children, className }: OrbProps): JSX.Element => {
    return (
        <div className={classes(Styles.orb, Styles[color], className)}>
            {children}
        </div>
    );
};
